module.exports = __webpack_public_path__ + "img/pnstidur.2e853d91.svg";